import logo from "../../assets/images/contact/plurato_logo.png";
import "./ThankYou.scss";

function ThankYou() {
  return (
    <section id="thankYou">
      <div className="thank_you_logo">
        <img src={logo} alt="Plurato Logo" />
      </div>
      <div className="thank_you_title">Thank you for flying with us.</div>
    </section>
  );
}

export default ThankYou;
